<div class="form-group" [class.invalid]="!fc?.valid && fc?.touched">
  <label for="country">
    {{ "LABELS.COUNTRY" | translate }}
    <i *ngIf="isShowRequired" class="fa fa-asterisk form-required" aria-hidden="true"></i>
  </label>
  <ng-select
    id="country"
    class="custom"
    [items]="countries"
    [loading]="countriesLoading"
    [typeahead]="countriesTypeahead"
    [(ngModel)]="selectedCountry"
    [disabled]="isDisabled"
    [clearable]="isClearable"
    (change)="onChangeCountry($event)"
  >
    <ng-template ng-label-tmp let-item="item">
      <span class="ng-value-label">{{ item.code }} {{ item.description }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <span>{{ item.code }} {{ item.description }}</span>
    </ng-template>
  </ng-select>
  <app-control-errors [control]="fc" [errors]="errors" [isShowHelper]="true"></app-control-errors>
</div>
